var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gift-section"},_vm._l((_vm.giftPlugins),function(plugin){return _c(plugin.component,_vm._g(_vm._b({key:plugin.id,tag:"component",attrs:{"pluginId":plugin.id}},'component',_vm.$attrs,false),_vm.$listeners))}),1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }